module.exports = __webpack_public_path__ + "static/media/super-g.a1b42af6.png";